import { render, staticRenderFns } from "./EnacProcedureAtpDafEditAtpResume.vue?vue&type=template&id=6c47a352"
import script from "./EnacProcedureAtpDafEditAtpResume.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditAtpResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports